const acronyms = new Set(["llm", "llms", "ai", "rts", "rpg", "xp", "pvp"]);
export function tagLabel(tag: string): string {
  return tag
    .replace(/[-_]+/g, " ")
    .split(" ")
    .map((word, i) =>
      acronyms.has(word)
        ? word.toUpperCase()
        : i === 0
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word,
    )
    .join(" ");
}
